import {TreeNode} from "react-organizational-chart";
import RenderComponents from "../../RenderComponents";
import React from "react";

const StyledTreeItemHorizontal = (props) => {
    const {component, doc} = props;
    return (
        <TreeNode {...props}
                  label={
                      <div
                          onDoubleClick={(e) => {
                              e.stopPropagation();
                              props.onDoubleClick(doc)
                          }}
                          style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                      >
                          {(component.children || []).map(element => {
                              return (
                                  <RenderComponents
                                      key={element.id}
                                      element={element}
                                      actionsContext={{doc}}
                                  />
                              )
                          })}
                      </div>}
        />
    )
}

export default StyledTreeItemHorizontal
